import { render, staticRenderFns } from "./FeatureItemExtra.vue?vue&type=template&id=55b738d7&scoped=true"
import script from "./FeatureItemExtra.vue?vue&type=script&lang=js"
export * from "./FeatureItemExtra.vue?vue&type=script&lang=js"
import style0 from "./FeatureItemExtra.vue?vue&type=style&index=0&id=55b738d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b738d7",
  null
  
)

export default component.exports